/* eslint-disable */

const defaultSort = 'updated';

const initialFilter = {
  // note(joeysapp): Just let the common DateRangeSelect handle the start date?
  // submitDateStart: filterStart.toISOString(),
  submitDateEnd: new Date(),
  submitted: null,
}

const initialState = {
  enrollments: [],
  sortTerm: defaultSort,
  sortInverse: true,
  // Pagination
  page: 1,
  pageSize: 20,
  totalPages: 0,
  totalItems: 0,
  loading: false,
  error: false,
  ...initialFilter,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'CLEAR_ENROLLMENTS': {
      return {
        ...state,
        // Seems like we need to reset the start/end dates that the daterangepicker may be changing?
        ...initialFilter,        
        enrollments: [],
      };
    }
    case 'LOAD_ENROLLMENTS': {
      let { Items: enrollments, TotalItems: totalItems, TotalPages: totalPages, PageSize: pageSize } = action.payload;
      let nextState = {
        ...state,
        enrollments,
        totalItems,
        totalPages,
        pageSize,
      };
      return nextState;
    }
    case 'ADD_ENROLLMENTS': {
      let { Items: enrollments } = action.payload;
      return {
        ...state,
        enrollments: [
          ...state.enrollments,
          ...enrollments,
        ],
      };
    }
    case 'SET_ENROLLMENT': {
      const { quote_id } = action.payload;
      return {
        ...state,
        enrollments: [
          ...state.enrollments.filter(e => e.quote_id !== quote_id),
          action.payload,
        ],
      };
    }
    case 'SET_ENROLLMENTS_SORT_TERM':
      /* eslint-disable no-case-declarations */
      const newSortTerm = action.payload ? action.payload : defaultSort;
      return { ...state, sortTerm: newSortTerm };
    /* eslint-enable no-case-declarations */
    case 'CLEAR_ENROLLMENTS_SORT_TERM':
      return { ...state, sortTerm: defaultSort };
    case 'SET_ENROLLMENTS_SORT_INVERSE':
      return { ...state, sortInverse: action.payload };
    case 'CLEAR_ENROLLMENTS_SORT_INVERSE':
      return { ...state, sortInverse: false };
    case 'SET_ENROLLMENTS_PAGE':
      return { ...state, page: action.payload };
    case 'SET_ENROLLMENTS_FILTER':
      return { ...state, ...action.payload };
    case 'CLEAR_ENROLLMENTS_FILTER':
      return { ...state, ...initialFilter };
    case 'SET_ENROLLMENTS_LOADING':
      return { ...state, loading: action.payload };
    case 'SET_ENROLLMENTS_ERROR':
      return { ...state, error: action.payload };
    case 'CLEAR_AGENT_LEADS':
      return initialState;
    case 'CLEAR_ENROLLMENTS':
      return initialState;
    default:
      return state;
  }
};
